import { Icon } from "../../components/icon/icon";
import { BgWrapper } from "../../components/wrapper/bgWrapper";

export const SecuritySettings = () => {
  return (
    <BgWrapper className="flex items-center gap-3">
      <Icon svg="padlock" width={20} height={20} />

      <div className="flex-1">
        <p className="text-base font-bold text-black">Change Password</p>
        <p className="text-sm text-grey-500">Last changed on </p>
      </div>

      <Icon
        svg="caret-down"
        width={20}
        height={20}
        className="-rotate-90 text-grey-600"
      />
    </BgWrapper>
  );
};
